import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

const createAPIKey = async apiKey => {
  await API.refreshTokenWhenNeeded();

  return fetch(`${baseUrl}/currentuser/api-keys`, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(apiKey)
  }).then(res => API.generateResponse(res));
};

const getAPIKeys = async (pageToken = '', pageSize = 200) => {
  await API.refreshTokenWhenNeeded();
  const query = new URLSearchParams({ pageSize: String(pageSize), pageToken });

  return fetch(`${baseUrl}/currentuser/api-keys?${query}`, {
    method: 'GET',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => API.generateResponse(res));
};

const deleteAPIKey = async keyId => {
  await API.refreshTokenWhenNeeded();

  return fetch(`${baseUrl}/currentuser/api-keys/${keyId}`, {
    method: 'DELETE',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() }
  }).then(res => API.generateResponse(res));
};

export { createAPIKey, getAPIKeys, deleteAPIKey };
